import { Component, EventEmitter, Input, Output } from '@angular/core';

// Interfaces
import { TooltipOptions } from 'primeng/api';

// Types
import { ButtonIconPosition, ButtonSeverity, ButtonSize, ButtonType } from './types';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  @Input() classList!: string;

  @Input() icon!: string;
  @Input() iconPos!: ButtonIconPosition;
  @Input() label!: string;
  @Input() link: boolean = false;
  @Input() loading: boolean = false;
  @Input() outlined: boolean = false;
  @Input() raised: boolean = false;
  @Input() rounded: boolean = false;
  @Input() severity: ButtonSeverity;
  @Input() size: ButtonSize;
  @Input() text: boolean = false;
  @Input() tooltip?: string;
  @Input() tooltipPosition: TooltipOptions['tooltipPosition'] = 'bottom';
  @Input() type: ButtonType = 'submit';

  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: unknown) {
    this._disabled = Boolean(value);
  }

  private _disabled: boolean = false;

  @Output() onClick = new EventEmitter<MouseEvent>();

  get buttonClasses(): any {
    return {
      // Severidad (Primario es 'undefined' o 'null')
      'p-button-secondary': this.severity === 'secondary',
      'p-button-success': this.severity === 'success',
      'p-button-info': this.severity === 'info',
      'p-button-warning': this.severity === 'warning',
      'p-button-help': this.severity === 'help',
      'p-button-danger': this.severity === 'danger',

      // Estilo
      'p-button-outlined': this.outlined,
      'p-button-text': this.text,
      'p-button-raised': this.raised,
      'p-button-rounded': this.rounded,
      'p-button-link': this.link,

      // Tamaño
      'p-button-sm': this.size === 'small',
      'p-button-lg': this.size === 'large',

      // Clases personalizadas que puedas pasar
      [this.classList]: !!this.classList,
    };
  }
}
